module.exports = __webpack_public_path__ + "assets/img/ps-1.0b527276.png";